import { useTranslation } from "react-i18next";
import { PlatformCustomCovers } from "@/partner/features/platformCustomCovers";
import { Meta } from "@/shared/components";

export const PlatformCustomCoversPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("platformCustomCovers.pageTitle")} pageType="Partner" />
      <PlatformCustomCovers />
    </>
  );
};
